import React, { useState, useEffect } from 'react';
import { Cookie, X, Shield } from 'lucide-react';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleConsent = (accepted: boolean) => {
    localStorage.setItem('cookieConsent', accepted ? 'accepted' : 'rejected');
    setIsVisible(false);

    if (accepted) {
      // Update consent state
      window.gtag('consent', 'update', {
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'ad_storage': 'granted',
        'analytics_storage': 'granted'
      });
    } else {
      // Keep consent denied
      window.gtag('consent', 'update', {
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
        'analytics_storage': 'denied'
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="bg-gray-800 light:bg-white border-t border-gray-700 light:border-gray-200 backdrop-blur-lg bg-opacity-95 p-4 md:p-6 shadow-lg transform transition-transform duration-300">
        <div className="container mx-auto max-w-4xl">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex items-start gap-3 flex-1">
              <Cookie className="h-6 w-6 text-blue-400 flex-shrink-0" />
              <div className="space-y-2">
                <h3 className="text-gray-100 light:text-gray-900 font-medium">Cookie Settings</h3>
                <p className="text-sm text-gray-300 light:text-gray-600">
                  We use cookies to enhance your experience and analyze site traffic. 
                  By clicking "Accept All", you consent to our use of cookies. 
                  <button 
                    onClick={() => window.open('/privacy', '_blank')}
                    className="text-blue-400 hover:text-blue-300 ml-1"
                  >
                    Learn more
                  </button>
                </p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
              <button
                onClick={() => handleConsent(false)}
                className="px-4 py-2 bg-gray-700 light:bg-gray-200 text-gray-300 light:text-gray-700 rounded-lg hover:bg-gray-600 light:hover:bg-gray-300 transition-colors flex-1 md:flex-none flex items-center justify-center gap-2"
              >
                <X className="h-4 w-4" />
                <span>Reject All</span>
              </button>
              <button
                onClick={() => handleConsent(true)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex-1 md:flex-none flex items-center justify-center gap-2"
              >
                <Shield className="h-4 w-4" />
                <span>Accept All</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;